import React from 'react';
// App.styles must be imported before any search components for correct CSS ordering.
import './App.styles';
import GAPSearch from './searches/gap/GAPSearch';
import HARSearch from './searches/har/HARSearch';
import NHLESearch from './searches/nhle/NHLESearch';
import TeachingActivitiesSearch from './searches/teaching-activities/TeachingActivitiesSearch';
import ResearchReportsSearch from './searches/research-reports/ResearchReportsSearch';
import EducationalImagesSearch from './searches/educational-images/EducationalImagesSearch';
import ArchiveSearch from './searches/archive/ArchiveSearch';
import SiteSearch from './searches/site/SiteSearch';
import PublicationsSearch from './searches/publications/PublicationsSearch';
import HeritageGateway from './searches/heritage-gateway/HeritageGatewaySearch';

export default function App() {
  const rootElement = document.getElementById('root');
  const searchType = rootElement?.getAttribute('data-search-type');

  switch (searchType) {
    case 'archive':
      return <ArchiveSearch />;
    case 'educational-images':
      return <EducationalImagesSearch />;
    case 'gap':
      return <GAPSearch />;
    case 'har':
      return <HARSearch />;
    case 'nhle':
      return <NHLESearch />;
    case 'research-reports':
      return <ResearchReportsSearch />;
    case 'site':
      return <SiteSearch />;
    case 'teaching-activities':
      return <TeachingActivitiesSearch />;
    case 'publications':
      return <PublicationsSearch />;
    case 'heritage-gateway':
      return <HeritageGateway />;
    default:
      return null;
  }
}
